module.exports = __webpack_public_path__ + "media/images/lb/951-b6afdaf3b278ee2e0089564152eb6cb2.svg";